import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=1c5aff24&"
import script from "./ModalTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5aff24')) {
      api.createRecord('1c5aff24', component.options)
    } else {
      api.reload('1c5aff24', component.options)
    }
    module.hot.accept("./ModalTemplate.vue?vue&type=template&id=1c5aff24&", function () {
      api.rerender('1c5aff24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ModalTemplate.vue"
export default component.exports